export const SELLER_POLICY_LINK =
  'https://upcyclershelp.helpscoutdocs.com/article/16-seller-policy';

export const HELP_CENTER_LINK =
  'https://upcyclershelp.helpscoutdocs.com';

export const TERMS_LINK =
  'https://upcyclershelp.helpscoutdocs.com/article/8-terms-of-service';

export const PRIVACY_LINK =
  'https://upcyclershelp.helpscoutdocs.com/article/13-privacy-policy';

export const FAQ_LINK =
  'https://upcyclershelp.helpscoutdocs.com/article/18-general';

export const SELLER_GUIDE_LINK =
  'https://upcyclershelp.helpscoutdocs.com/article/22-seller-guide';

export const PROHIBITED_PRODUCTS_LINK =
  'https://upcyclershelp.helpscoutdocs.com/article/24-prohibited-products-and-listing-standards';
